<script setup>
defineProps({ content: Object, heroClass: String })
defineEmits(['action'])
function handleClick(e) {
  e.preventDefault()
}
</script>

<template>
  <div class="mt-mobile-navbar w-full pt-12 lg:mt-desktop-navbar lg:pt-20 lg:!overflow-visible" @contextmenu.prevent="handleClick">
    <div class="relative w-full 3xl:min-h-[550px] 3xl:min-h-[600px] xl:min-h-[650px] lg:flex lg:items-center">
      <div class="relative h-full container">
        <div class="max-w-full lg:mb-0 lg:mr-8 2xl:max-w-2xl xl:max-w-xl lg:pr-0">
          <div
            class="flex items-center text-md text-secondary-red-100 font-semibold uppercase lg:text-xl md:text-xl sm:text-lg"
          >
            <span
              class="mr-4 h-[2px] w-6 bg-secondary-red-100 lg:w-10 md:w-8"
            />
            {{ content.header }}
          </div>
          <h1
            v-if="content.title"
            class="line-clamp-4 text-2xl text-primary font-bold leading-[1.2] uppercase 2xl:text-7xl lg:text-6xl md:text-4xl sm:text-3xl sm:text-4xl"
          >
            {{ content.title }}
          </h1>
          <p
            v-if="content.subtitle"
            class="line-clamp-5 mt-4 text-lg text-primary font-normal leading-[1.6] lg:mt-6 md:leading-[1.8] sm:leading-[1.7]"
          >
            {{ content.subtitle }}
          </p>
          <slot />
        </div>
      </div>
      <UIHexagon custom-class="absolute right-0 lg:bottom-0 lg:right-unset lg:left-0 z-[-1] lg:translate-y-[50%] lg:translate-x-[-25%]" size="w-[250px] xl:w-[350px] w-[250px] xl:h-[350px]" />
      <div class="absolute inset-y-0 right-[-15%] z-[-1] hidden h-full w-full 2xl:right-[-10%] 3xl:right-[-2%] xl:flex">
        <div
          class="h-full w-full flex xl:items-end lg:items-center"
        >
          <div
            class="mask relative z-20 ml-auto h-full w-full" :style="{
              backgroundImage: `url(${content.url})`,
              backgroundPosition: 'right',
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
            }"
          />
          <svg
            class="absolute right-0 z-[-0] w-auto scale-[112.5%] 2xl:h-[600px] lg:h-[475px] xl:h-[550px]" xmlns="http://www.w3.org/2000/svg" width="536.1" height="447.7" viewBox="0 0 536.1 447.7"
          >
            <path id="industries-stroke-1" d="m150.4,447.4c-17.8,0-34.3-9.5-43.2-24.9L7,248.8c-8.9-15.4-8.9-34.4,0-49.9L107.2,25.2C116.2,9.8,132.6.3,150.4.3h385.4v447.1H150.4Z" fill="none" stroke="#ee2334" stroke-miterlimit="10" stroke-width=".6" />
            <path id="industries-stroke-2" d="m150.4,444c-16.6,0-31.9-8.9-40.3-23.3L9.9,247.1c-8.3-14.4-8.3-32.1,0-46.5L110.1,26.9c8.3-14.4,23.7-23.2,40.3-23.3h382v440.4H150.4Z" fill="none" stroke="#ee2334" stroke-miterlimit="10" stroke-width="1.2" />
            <path id="industries-stroke-3" d="m150.4,439.5c-15,0-28.9-8-36.4-21L13.8,244.9c-7.5-13-7.5-29,0-42L114,29.2c7.5-13,21.4-21,36.4-21h377.5v431.4H150.4Z" fill="none" stroke="#ee2334" stroke-miterlimit="10" stroke-width="1.8" />
            <path id="industries-stroke-4" d="m150.4,433.9c-13,0-25-7-31.5-18.2L18.6,242.1c-6.5-11.3-6.5-25.1,0-36.4L118.9,32c6.5-11.3,18.5-18.2,31.5-18.2h371.9v420.2H150.4Z" fill="none" stroke="#ee2334" stroke-miterlimit="10" stroke-width="2.4" />
          </svg>
        </div>
      </div>
      <div class="absolute inset-0 z-[-11] h-full w-full bg-white pb-[8rem] lg:pb-0 md:pb-[18rem] sm:pb-[16rem] xs:pb-[10rem]" />
    </div>
  </div>
</template>

<style scoped>
#industries-stroke-1 {
  stroke-linecap: round;
  stroke-dasharray: 166, 2000;
  stroke-dashoffset: -163;
  /* animation: dash1 5s linear infinite; */
}

#industries-stroke-2 {
  stroke-linecap: round;
  stroke-dasharray: 162, 2000;
  stroke-dashoffset: -160;
  /* animation: dash2 5s linear infinite; */
}

#industries-stroke-3 {
  stroke-linecap: round;
  stroke-dasharray: 157, 2000;
  stroke-dashoffset: -155;
  /* animation: dash3 5s linear infinite; */
}

#industries-stroke-4 {
  stroke-linecap: round;
  stroke-dasharray: 150, 2000;
  stroke-dashoffset: -150;
  /* animation: dash4 5s linear infinite; */
}

@keyframes dash1{
  0% {
    stroke-dashoffset: 2000;
  }
  100% {
    stroke-dashoffset: -163;
  }
}
@keyframes dash2{
  0% {
    stroke-dashoffset: 2000;
  }
  100% {
    stroke-dashoffset: -160;
  }
}
@keyframes dash3{
  0% {
    stroke-dashoffset: 2000;
  }
  100% {
    stroke-dashoffset: -155;
  }
}
@keyframes dash4{
  0% {
    stroke-dashoffset: 2000;
  }
  100% {
    stroke-dashoffset: -150;
  }
}
.mask {
  mask-size: contain;
  mask-repeat: no-repeat;
  mask-position: right;
  mask-image: url('/svg/triangle_left.svg');
}
</style>
